import { BasicClient } from '@/utils/httpClient'

export default class IA {
  client
  constructor() {
    this.client = new BasicClient()
  }
  getQuestions() {
    return this.client.exec('/ai/documents/questions', 'GET')
  }
  getTermsAndCondition() {
    return this.client.exec('/ai/documents/termsacept', 'GET')
  }
  postTermsAndCondition(termsAndConfigData) {
    return this.client.exec(
      '/ai/documents/termsacept',
      'POST',
      termsAndConfigData
    )
  }
  getAnswer(idDocument, idQuestion, downloadAudio = false) {
    const params = {
      questId: idQuestion
    };
    const url = `/ai/documents/speak/${idDocument}`;
  
    return downloadAudio
      ? this.client.downloadAudioFile(url, 'GET', params)
      : this.client.exec(url, 'GET', params);
  }
}
